import { beforeEnterHasPerm } from '@/components/PermissionHelper'

const beforeEnter = (to, from, next) => { return beforeEnterHasPerm(to, from, next) }

const ROUTES = {
  CONTACT_TITLE_LIST: 'organization-contact-title'
}

const routes = [
  {
    path: 'contact-title/',
    name: ROUTES.CONTACT_TITLE_LIST,
    beforeEnter: beforeEnter,
    meta: {
      permissions: ['organization_contacttitle_list'],
      requiresAuth: true
    },
    component: () => import('./ContactTitleList.vue')
  }

]

export { routes, ROUTES }
